import { render, staticRenderFns } from "./Disciplines.vue?vue&type=template&id=33f4172e&"
import script from "./Disciplines.vue?vue&type=script&lang=js&"
export * from "./Disciplines.vue?vue&type=script&lang=js&"
import style0 from "./Disciplines.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports